import React from 'react';
import { arrayOf, object, string } from 'prop-types';
import _ from 'lodash';
import { I18n } from '@fiverr-private/fiverr_context';
import { getAttributeOptionKey, getAttributeTitleKey } from '../../../../utils/translation/extendedAttributes';

import './style.scss';

const MetadataAttribute = ({ name, options }, { general }) => {
    const validOptions = _.uniq(_.compact(options));

    if (!(name && validOptions.length > 0)) {
        return null;
    }

    return (
        <li className="metadata-attribute">
            <p>
                <I18n k={getAttributeTitleKey(name, general.subCategoryId)}/>
            </p>
            <ul>
                {
                    validOptions.map((option) => (
                        <li key={option}>
                            <I18n k={getAttributeOptionKey(name, option, general.subCategoryId)}/>
                        </li>
                    ))
                }
            </ul>
        </li>
    );
};

MetadataAttribute.propTypes = {
    name: string,
    options: arrayOf(string)
};

MetadataAttribute.contextTypes = {
    general: object
};

export default MetadataAttribute;
